import { Injectable } from '@angular/core';
import { BcAnalytics } from 'common/analytics/analytics.service';
import { BcAuth } from 'common/auth/auth.service';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { CommonAuthService } from 'common/auth/common-auth.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutResolverService implements Resolve<Promise<void>> {
  constructor(private _auth: BcAuth,
              private commonAuthService: CommonAuthService,
              private _analytics: BcAnalytics) {
  }

  async resolve(activatedRouteSnapshot: ActivatedRouteSnapshot): Promise<void> {
    this._analytics.eventTrack('Logout', { from: 'logoutUrl' });

    this._auth.persistDisableCommonLoginParameter(activatedRouteSnapshot);
    return await this.commonAuthService.logout(undefined, activatedRouteSnapshot.queryParams.return);
  }
}
